// import { Supplier } from '../../interfaces/Supplier'
import { SupplierAction } from '../actions/SupplierActions'
import { SuppliersEntity } from '../../interfaces/Supplier/Supplier'
import { supplierActionsTypes } from '../types/supplierActionsTypes'

export interface SupplierState {
  suppliersState: {
    suppliers?: SuppliersEntity[] | undefined
    error?: string | undefined
  }
}

const initialState: SupplierState = {
  suppliersState: { suppliers: [], error: '' }
}

export const suppliersReducer = (
  state: SupplierState = initialState,
  action: SupplierAction
): SupplierState => {
  if (action.type === supplierActionsTypes.GET_SUPPLIERS_EXITO) {
    return {
      ...state,
      suppliersState: {
        suppliers: action.suppliers,
        error: action.error
      }
    }
  }
  return state
}
